import React, { memo, PropsWithChildren, } from 'react';
import { IPosition, PlacesType, Tooltip } from 'react-tooltip'
export type tooltipSideType = "RSB" | "LSB";
type TooltipProps = {
    id: string; // Unique ID for the tooltip
    content: string  | JSX.Element; // The content of the tooltip
    place?: PlacesType | undefined // Tooltip position
    effect?: 'float' | 'solid'; // Tooltip effect
    className?: string; // Optional custom class for the tooltip
    Side:tooltipSideType
    isClickable?:boolean
    position?:IPosition | false;
    isopen?:boolean| undefined
    maxWidth?:string
    delayHide?:number
};

const ReactToolTip: React.FC<PropsWithChildren<TooltipProps>> = ({delayHide,id,content,children,place = "top",effect = "solid",className = "",Side,isClickable = false,position,isopen=undefined,maxWidth}) => {
  return (
    <>
      {children ? children : <></>}
      <Tooltip
        // anchorSelect={`[data-tooltip-id="${id}"]`}
        // offset={200}
       delayHide={delayHide??10}
       isOpen={isopen}
        clickable={isClickable}
        opacity={1}
        style={{
          backgroundColor: `${
            Side === "RSB" ? "rgb(255 255 255 / var(--tw-bg-opacity))" : ""
          }`,
          color: `${Side === "RSB" ? "black" : ""}`,
          zIndex: 99999999999999,
          maxWidth: maxWidth || "15vw",
        }}
        position={position ? position : undefined}
        id={id}
        place={place}
        className={className}
      >
        {content}
      </Tooltip>
    </>
  );
};

export default memo(ReactToolTip)